module.exports = __webpack_public_path__ + "img/品牌赛事_4@2x.223b67de.png";